'use client';

import { useEffect } from 'react';
import { installTableColumnResizing } from '@/lib/auto-table-resize.mjs';

export default function AutoTableResize() {
  useEffect(() => installTableColumnResizing(), []);
  return null;
}
